/*
  Load sections's styles/scripts on demand
*/
document.querySelectorAll("[data-section-css]").forEach((el) => {
  const hrefs = el.dataset.sectionCss.split(",");

  hrefs.forEach((href) => {
    if (document.querySelector(`link[href="${href.trim()}"]`)) return;
    const link = document.createElement("link");
    link.href = href;
    link.rel = "stylesheet";
    document.head.appendChild(link);
  });
});

document.querySelectorAll("[data-section-js]").forEach((el) => {
  const srcs = el.dataset.sectionJs.split(",");

  srcs.forEach((src) => {
    if (document.querySelector(`script[src="${src.trim()}"]`)) return;
    const script = document.createElement("script");
    script.src = src;
    script.defer = true;
    document.head.appendChild(script);
  });
});

/*
  Shopify's errors messages
*/
document.querySelectorAll(".errors").forEach((element) => {
  element.classList.add("alert");
  element.setAttribute("data-alert-type", "error");
});

/*
  Shopify's challenge page
*/
document.querySelector(".btn.shopify-challenge__button")?.classList.add("btn-primary");

/*
  Viewport detection
*/
document.querySelectorAll("[data-viewport-entered]").forEach((el) => {
  let marginBottom = -100;

  if (el.offsetHeight < 100 || el.dataset.viewportSmall === "true") {
    marginBottom = -30;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.dataset.viewportEntered = "true";
          observer.unobserve(entry.target);

          if (entry.target.dataset.videoAutoplay === "true") {
            entry.target.querySelectorAll("video").forEach((video) => {
              video.muted = true;
              video.play();
            });
          }

          if (entry.target.dataset.externalVideoLazyload === "true") {
            entry.target.querySelectorAll("iframe[data-src]").forEach((iframe) => {
              iframe.src = iframe.dataset.src;
              iframe.removeAttribute("data-src");
            });
          }
        }
      });
    },
    {
      rootMargin: `0px 0px ${marginBottom}px 0px`,
    },
  );

  observer.observe(el);
});

/*
  Shopify's money format
*/
window.Shopify.formatMoney = function (cents, format) {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }

  const defaultFormat = window.Shopify.money_format || "${{amount}}";
  const formatString = format || defaultFormat;

  const formatWithDelimiters = (number, precision = 2, thousands = ",", decimal = ".") => {
    if (isNaN(number) || number == null) return "0";

    number = (number / 100).toFixed(precision);
    const [integerPart, decimalPart] = number.split(".");
    const formattedInt = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);

    return decimalPart ? `${formattedInt}${decimal}${decimalPart}` : formattedInt;
  };

  const placeholderMatch = formatString.match(/{{\s*(\w+)\s*}}/);
  if (!placeholderMatch) return cents;

  const placeholder = placeholderMatch[1];
  let value;

  switch (placeholder) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    default:
      value = formatWithDelimiters(cents, 2);
  }

  return formatString.replace(placeholderMatch[0], value);
};

// Resize images
window.Shopify.resizeImage = function (src, size, crop = "") {
  if (src)
    return src
      .replace(
        /_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g,
        "."
      )
      .replace(/\.jpg|\.png|\.gif|\.jpeg/g, (match) => {
        if (crop.length) {
          crop = `_crop_${crop}`;
        }
        return `_${size}${crop}${match}`;
      });
  else
    return "data:image/svg+xml,%3Csvg class='placeholder-svg' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 525.5 525.5'%3E%3Cpath d='M324.5 212.7H203c-1.6 0-2.8 1.3-2.8 2.8V308c0 1.6 1.3 2.8 2.8 2.8h121.6c1.6 0 2.8-1.3 2.8-2.8v-92.5c0-1.6-1.3-2.8-2.9-2.8zm1.1 95.3c0 .6-.5 1.1-1.1 1.1H203c-.6 0-1.1-.5-1.1-1.1v-92.5c0-.6.5-1.1 1.1-1.1h121.6c.6 0 1.1.5 1.1 1.1V308z'%3E%3C/path%3E%3Cpath d='M210.4 299.5H240v.1s.1 0 .2-.1h75.2v-76.2h-105v76.2zm1.8-7.2l20-20c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l1.5 1.5 16.8 16.8c-12.9 3.3-20.7 6.3-22.8 7.2h-27.7v-5.5zm101.5-10.1c-20.1 1.7-36.7 4.8-49.1 7.9l-16.9-16.9 26.3-26.3c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l27.5 27.5v7.8zm-68.9 15.5c9.7-3.5 33.9-10.9 68.9-13.8v13.8h-68.9zm68.9-72.7v46.8l-26.2-26.2c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-26.3 26.3-.9-.9c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-18.8 18.8V225h101.4z'%3E%3C/path%3E%3Cpath d='M232.8 254c4.6 0 8.3-3.7 8.3-8.3s-3.7-8.3-8.3-8.3-8.3 3.7-8.3 8.3 3.7 8.3 8.3 8.3zm0-14.9c3.6 0 6.6 2.9 6.6 6.6s-2.9 6.6-6.6 6.6-6.6-2.9-6.6-6.6 3-6.6 6.6-6.6z'%3E%3C/path%3E%3C/svg%3E";
};


/*
  Header
*/
class ThemeHeader extends HTMLElement {
  constructor() {
    super();
    
    this.headerGroup = document.querySelector("#header-group");
    this.stickyHeader();
    this.mobileMenu();
    this.desktopMenu();
    this.transparentHeader();
  }

  stickyHeader() {
    const forceAlways = document.body?.dataset?.bulkQtyStickyHeader === "true";
    const mode = forceAlways ? "always" : this.dataset.stickyHeader;

    switch (mode) {
      case "none":
        return;
      case "scroll-up": {
          this.headerGroup.classList.add("sticky");
          let lastScrollTop = 0;
          let ticking = false;

          window.addEventListener("scroll", () => {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(() => {
              const currentScroll = window.pageYOffset;
              if (currentScroll > lastScrollTop && currentScroll > this.headerGroup.clientHeight) {
                this.headerGroup.classList.add("hide");
              } else {
                this.headerGroup.classList.remove("hide");
              }
              lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
              ticking = false;
            });
          }, { passive: true });
          break;
        }
      case "always": {
          this.headerGroup.classList.add("sticky");
          break;
        }
      default:
      break;
    }
  }

  mobileMenu() {
    const toggler = this.querySelector('[aria-controls="header-mobile-menu"]');
    const menu = this.querySelector("#header-mobile-menu");
    const nav = this.querySelector("#header-mobile-nav");

    const openMenu = () => {
      toggler.setAttribute("aria-expanded", "true");
      menu.hidden = false;
      menu.nextElementSibling.hidden = false;
      document.body.style.overflow = "hidden";

      const top = document.querySelector("#header-group.sticky")?.offsetHeight || 0;
      menu.style.setProperty("--top", `${top}px`);
      menu.nextElementSibling.style.setProperty("--top", `${top}px`);

      document.addEventListener("keydown", handleFocus);
      document.addEventListener("click", handleOutsideClick);
    };

    const closeMenu = () => {
      menu.classList.add("closing");
      menu.addEventListener(
        "animationend",
        () => {
          toggler.setAttribute("aria-expanded", "false");
          menu.classList.remove("closing");
          menu.hidden = true;
          menu.nextElementSibling.hidden = true;
          document.body.style.overflow = "";

          menu.style.removeProperty("--top");
          menu.nextElementSibling.style.removeProperty("--top");

          nav.querySelectorAll('[aria-expanded="true"]').forEach((link) => link.setAttribute("aria-expanded", "false"));
          document.removeEventListener("keydown", handleFocus);
          document.removeEventListener("click", handleOutsideClick);
        },
        { once: true },
      );
    };

    nav.querySelectorAll("a[aria-expanded]").forEach((link) => {
      const parentLink = link.closest(".mobile-nav-dropdown")?.previousElementSibling;

      link.addEventListener("click", async (event) => {
        event.preventDefault();
        await new Promise((resolve) => setTimeout(resolve, 150));

        if (link.classList.contains("has-arrow-left")) {
          parentLink.setAttribute("aria-expanded", "false");
        } else {
          link.setAttribute("aria-expanded", "true");
        }
      });
    });

    const handleFocus = (event) => {
      if (event.key === "Tab") {
        if (document.activeElement.closest(".mobile-nav-dropdown")) {
          const dropdown = document.activeElement.closest(".mobile-nav-dropdown");
          const focusableElements = dropdown.querySelectorAll("a", "button");
          const firstElement = focusableElements[0];
          const lastElement = focusableElements[focusableElements.length - 1];

          if (document.activeElement === lastElement && !event.shiftKey) {
            event.preventDefault();
            firstElement.focus();
          } else if (document.activeElement === firstElement && event.shiftKey) {
            event.preventDefault();
            lastElement.focus();
          }
        } else {
          const focusableElements = menu.querySelectorAll("a", "button");
          const firstElement = focusableElements[0];
          const lastElement = focusableElements[focusableElements.length - 1];

          if (document.activeElement === toggler) {
            if (event.shiftKey) {
              event.preventDefault();
              lastElement.focus();
            } else {
              event.preventDefault();
              firstElement.focus();
            }
          } else if (document.activeElement === lastElement && !event.shiftKey) {
            event.preventDefault();
            toggler.focus();
          } else if (document.activeElement === firstElement && event.shiftKey) {
            event.preventDefault();
            toggler.focus();
          }
        }
      }

      if (event.key === "Enter" || event.key === " ") {
        if (document.activeElement.classList.contains("has-arrow-left")) {
          const parentLink = document.activeElement.closest(".mobile-nav-dropdown").previousElementSibling;
          parentLink.setAttribute("aria-expanded", "false");
          parentLink.focus();
        } else if (document.activeElement.classList.contains("has-arrow-right")) {
          document.activeElement.setAttribute("aria-expanded", "true");
          const dropdown = document.activeElement.nextElementSibling;
          setTimeout(() => dropdown.querySelector("a").focus(), 200);
        }
      }

      if (event.key === "Escape") {
        if (document.activeElement.closest(".mobile-nav-dropdown")) {
          document.activeElement.closest(".mobile-nav-dropdown").previousElementSibling.setAttribute("aria-expanded", "false");
          document.activeElement.closest(".mobile-nav-dropdown").previousElementSibling.focus();
        } else {
          closeMenu();
          toggler.focus();
        }
      }
    };

    const handleOutsideClick = (event) => {
      if (document.querySelector("#header-mobile").contains(event.target) && !toggler.contains(event.target)) {
        closeMenu();
      }
    };

    toggler.addEventListener("click", (event) => {
      event.preventDefault();
      const isExpanded = toggler.getAttribute("aria-expanded") === "true";
      isExpanded ? closeMenu() : openMenu();
    });

    document.addEventListener("shopify:block:select", (event) => {
      if (event.target.querySelector("#header-mobile-menu")) {
        openMenu();
      }
    });
  }

  desktopMenu() {
    this.querySelectorAll("#header-desktop .dropdown-btn").forEach((link) => {
      link.addEventListener("dropdown:open", () => {
        document.body.setAttribute("data-header-dropdown-open", "");
      });
      link.addEventListener("dropdown:close", () => {
        setTimeout(() => {
          if (!this.querySelector('#header-desktop .dropdown-btn[aria-expanded="true"]')) {
            document.body.removeAttribute("data-header-dropdown-open");
          }
        }, 100);
      });
    });
  }

  transparentHeader() {
    const hasTransparentHeader = this.headerGroup?.dataset.transparentHeader === "true";
    if (!hasTransparentHeader) return;

    let transparentTicking = false;
    window.addEventListener("scroll", () => {
      if (transparentTicking) return;
      transparentTicking = true;
      requestAnimationFrame(() => {
        if (window.pageYOffset > this.headerGroup.clientHeight) {
          this.headerGroup.setAttribute("data-transparent-header", "false");
          this.headerGroup.style.position = "fixed";
          this.headerGroup.style.width = "100%";
        } else if (!document.querySelector('#header-desktop .dropdown-btn[aria-expanded="true"]')) {
          this.headerGroup.setAttribute("data-transparent-header", "true");
          this.headerGroup.style.position = "";
          this.headerGroup.style.width = "";
        }
        transparentTicking = false;
      });
    }, { passive: true });

    document.querySelectorAll("#header-desktop .dropdown-btn").forEach((link) => {
      link.addEventListener("dropdown:open", () => {
        if (window.pageYOffset <= this.headerGroup.clientHeight) {
          this.headerGroup.setAttribute("data-transparent-header", "false");
          this.headerGroup.style.position = "fixed";
          this.headerGroup.style.width = "100%";
        }
      });
      link.addEventListener("dropdown:close", () => {
        setTimeout(() => {
          if (window.pageYOffset <= this.headerGroup.clientHeight && !document.querySelector('#header-desktop .dropdown-btn[aria-expanded="true"]')) {
            this.headerGroup.setAttribute("data-transparent-header", "true");
          }
        }, 100);
      });
    });

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.target.getAttribute("aria-expanded") === "true") {
          this.headerGroup.setAttribute("data-transparent-header", "false");
          this.headerGroup.style.position = "fixed";
          this.headerGroup.style.width = "100%";
        } else {
          if (window.pageYOffset <= this.headerGroup.clientHeight) {
            this.headerGroup.setAttribute("data-transparent-header", "true");
          }
        }
      });
    });

    observer.observe(document.querySelector('[aria-controls="header-mobile-menu"]'), {
      attributes: true,
      attributeFilter: ["aria-expanded"]
    });
  }
}
customElements.define("theme-header", ThemeHeader);


/*
  Footer
*/
class ThemeFooter extends HTMLElement {
  constructor() {
    super();

    this.fixedFooter();
  }

  fixedFooter() {
    const hasFixedFooter = this.dataset.fixedDesktop === "true";
    if (!hasFixedFooter) return;

    const setMargin = async () => {
      await new Promise((resolve) => setTimeout(resolve, 500));
      const footerHeight = document.querySelector("#footer-group").offsetHeight;

      if (window.matchMedia("(min-width: 1200px)").matches && footerHeight < window.innerHeight) {
        document.body.classList.add("has-fixed-footer");
        document.querySelector("#main").style.marginBottom = `${footerHeight}px`;
      } else {
        document.body.classList.remove("has-fixed-footer");
        document.querySelector("#main").style.marginBottom = "0";
      }
    };
    setMargin();
    let resizeTimer;
    const debouncedSetMargin = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(setMargin, 150);
    };
    window.addEventListener("resize", debouncedSetMargin);
    window.addEventListener("orientationchange", debouncedSetMargin);

    this.addEventListener('focusin', () => {
      if (document.body.classList.contains("has-fixed-footer")) {
        window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
      }
    });
  }
}
customElements.define("theme-footer", ThemeFooter);


/*
  JudgeMe app - Product reviews
*/
(() => {
  const wrapper = document.querySelector(".shopify-app-block[data-block-handle='review_widget']");
  if (!wrapper) return;

  wrapper.classList.add('container')
})();

/*
  Theme info
*/
console.info(
  "%Bold theme%c v1.0.0 %cby GeniusMakerAcademy%c https://GeniusMakerAcademy.com",
  "background:#020617;color:#f9fafb;padding:2px 8px;border-radius:4px;font-weight:700;",
  "font-weight:700;",
  "",
  ""
);
